// extracted by mini-css-extract-plugin
export default {"checkbox":"B2lzpHP0","warning":"egsZTzXN","accountLink":"mSBmBqo6","accountLink_inner":"FsSJDg8c","accountLinkInner":"FsSJDg8c","penultimate":"T7L1H3Tm"};